import { selectBuildingsInfoByTypeId } from "../../../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../../../utils/utilBuildings";
import { utilFunction } from "../../../../../utils/utilFunction";
export var checkBuildingNotProductionDoneState = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var taskType = action.taskType;
    var availableBuildings = selectBuildingsInfoByTypeId(state, taskType.buildingId);
    return availableBuildings.some(utilFunction.negate(utilBuildings.hasFinishedProduction))
        ? path
        : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-building/checks/checkBuildingNotProductionDoneState.ts
// module id = 2375
// module chunks = 3